import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "../../../../styles/Catalogue/SimilarBrands.module.scss";

export class DuplicateBrands extends Component {
  static propTypes = {
    brand: PropTypes.object.isRequired,
    duplicateBrands: PropTypes.array.isRequired,
  };

  componentDidMount = () => {
    this.el.scrollIntoView({ behavior: "smooth" });
  };

  getStatusText = (brand) => {
    const status = brand.status;

    switch (status) {
      case "PENDING":
      case "Pending":
        return "Pending Approval";

      case "APPROVED":
      case "Approved":
        return "Approved";

      case "ACTIVE":
      case "Active":
        return "Active";

      case "INACTIVE":
      case "Inactive":
        return "Inactive";

      case "REJECTED":
      case "Rejected":
        return "Rejected";

      default:
        return status || "Unknown";
    }
  };

  getStatusColor = (status) => {
    const normalizedStatus = (status || "").toLowerCase();

    if (normalizedStatus.includes("approved")) return "#5aa469";
    if (normalizedStatus.includes("inactive")) return "#a7a7a7";
    if (normalizedStatus.includes("pending")) return "#eba437";
    if (normalizedStatus.includes("active")) return "#5aa469";
    if (normalizedStatus.includes("rejected")) return "#d9534f";

    return "#a7a7a7";
  };

  render() {
    const { duplicateBrands } = this.props;

    return (
      <div
        className={`flex col-12 flex-wrap ${styles.similarBrands}`}
        ref={(el) => {
          this.el = el;
        }}
      >
        <div
          style={{
            border: "1px solid #c8d0d8",
            borderRadius: "10px",
            overflow: "hidden",
            width: "100%",
            background: "#fff",
          }}
        >
          <div
            style={{
              display: "flex",
              background: "#e2e7ec",
              fontWeight: 600,
              fontSize: "15px",
              color: "#2f3844",
              borderBottom: "1px solid #c8d0d8",
            }}
          >
            <div style={{ flex: 1, padding: "12px 18px" }}>Brand Name</div>
            <div style={{ width: "220px", padding: "12px 18px", textAlign: "right" }}>Status</div>
          </div>

          {duplicateBrands.map((duplicateBrand, index) => {
            const duplicateBrandData = duplicateBrand.brand || duplicateBrand;
            const status = this.getStatusText(duplicateBrandData);
            const statusColor = this.getStatusColor(status);

            return (
              <div
                key={duplicateBrandData.id || duplicateBrand.id || index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  borderBottom: index === duplicateBrands.length - 1 ? "none" : "1px solid #e1e5ea",
                }}
              >
                <div
                  style={{
                    flex: 1,
                    padding: "13px 18px",
                    color: "#0b5fa5",
                    fontWeight: 500,
                  }}
                >
                  {duplicateBrandData.name || duplicateBrand.name}
                </div>

                <div
                  style={{
                    width: "220px",
                    padding: "13px 18px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: "12px",
                    color: "#2f3844",
                  }}
                >
                  <span
                    style={{
                      width: "10px",
                      height: "10px",
                      borderRadius: "50%",
                      background: statusColor,
                      display: "inline-block",
                    }}
                  />
                  <span>{status}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default DuplicateBrands;
